(function () {
  const notFoundPage = document.querySelector('.not-found');
  if (!notFoundPage) return;
  const topBackLink = document.querySelector('.not-found__top-back-btn');
  const backLink = document.querySelector('.not-found__back-btn');
  topBackLink.setAttribute('href', document.referrer);
  backLink.setAttribute('href', document.referrer);
})();
